<project-summary-calendar
  [loading]="loading"
  [events]="projectStatistics?.upcomingEvents"
></project-summary-calendar>
